import { noop } from 'lodash';

import { createContext } from 'use-context-selector';

import { FormControlChildrenParams } from '../FormControl';
import { EnterKeyHint } from '../Form.types';

interface FormDatepickerContextProps
  extends Omit<FormControlChildrenParams, 'ref' | 'enterKeyHint'> {
  id: string;
  name: string;
  enterKeyHint: EnterKeyHint;
  placeholder?: string;
  defaultValue?: string;
}

export const FormDatepickerContext = createContext<FormDatepickerContextProps>({
  invalid: false,
  onBlur: noop,
  onChange: noop,
  value: undefined,
  id: 'id',
  name: 'name',
  enterKeyHint: 'next',
});
